import { Component } from "@angular/core";
import {
  NavController,
  NavParams,
  AlertController,
  ModalController
} from "ionic-angular";
import { TranslateService } from "@ngx-translate/core";
import { AppUtilities } from "../../app/app.utilities";
import { FannelInfoPage } from "../fannel-info/fannel-info";
import { HelpModalPage } from "../help-modal/help-modal";
import { WalletPage } from "../wallet/wallet";

@Component({
  selector: "page-help",
  templateUrl: "help.html"
})
export class HelpPage {
  email = "info@watafan.com";
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public utilities: AppUtilities,
    private translateService: TranslateService,
    public alertCtrl: AlertController,
    public modalCtrl: ModalController
  ) {}

  ionViewDidLoad() {
    console.log("ionViewDidLoad HelpPage");
  }

  openTelegram() {
    console.log("Telegram");
    const url = "https://t.me/Watafan";
    //Abre la URL en el navegador del sistema
    window.open(url, "_system");
  }

  onCopyAddress() {
    this.utilities.toast(this.translateService.instant("help.alert_message"));
  }

  goFannelInfoPage() {
    const modal = this.modalCtrl.create(FannelInfoPage);
    modal.present();
  }

  openAlertSeedsInfo() {
    /*const alert = this.alertCtrl.create({
      subTitle: this.translateService.instant("SEEDS_INFO"),
      buttons: ["OK"]
    });
    alert.present();*/
    var title = this.translateService.instant("help_modal.title_semilla");
    var description = this.translateService.instant("help_modal.desc_semilla");
    this.openModal(title, description, true);
  }

  goWatacarPremiumInfo() {
    var title = this.translateService.instant("help_modal.title_wata_premium");
    var description = this.translateService.instant(
      "help_modal.desc_wata_premium"
    );
    this.openModal(title, description, false);
  }

  openModal(title: string, description: string, seed: boolean) {
    const modal = this.modalCtrl.create(HelpModalPage, {
      title: title,
      description: description,
      seed: seed
    });

    modal.onDidDismiss(data => {
      if (data) this.navCtrl.push(WalletPage);
    });
    modal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/help/help.ts